import { tabAccessControl } from "../../../_helpers/access-control";


function PurchaseListTabs() {
  return [
    {
      text: "All",
      path: `/purchase-order`,
      applicationFeatureCode: "PurchaseOrder",
    },
    {
      text: "To Receive",
      path: `/goods-in`,
      applicationFeatureCode: "GoodsIn",
    },
    {
      text: "Received",
      path: `/goods-in-review`,
      applicationFeatureCode: "GoodsIn",
    },
    {
      text: "Invoiced",
      path: `/supplier-invoiced`,
      applicationFeatureCode: "SupplierInvoice",
    },
    {
      text: "Purchase Order Interrogation",
      path: `/purchase-order-interrogation`,
      applicationFeatureCode: "PurchaseOrder",
    },
    {
      text: "Goods In Interrogation",
      path: `/goods-in-interrogation`,
      applicationFeatureCode: "GoodsIn",
    }
  ]
}


function GetIndexByTabName(tabName) {
  return tabAccessControl(PurchaseListTabs()).findIndex((x) => x.text == tabName);
}

export { PurchaseListTabs, GetIndexByTabName };